// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_dy-0";
export var fileCarousel = "_dy-2";
export var removeFileButton = "_dy-1";